import axios from 'axios'
import type { release, relfilter,Updaterelease,addrelease } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'release'

export const readReleaseListAPI = async (relfilter: relfilter): Promise<release[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ...relfilter
    }
  })
  console.log("readReleaseListAPI 응답:", response.data)
  return response.data.data
}

export const itemReleaseAPI = async (id: number): Promise<release[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'item',
      id: id
    }
  })
  console.log("itemReleaseAPI 응답:", response.data)
  return response.data.data
}

export const addReleaseAPI = async (addrelease: addrelease) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
      ...addrelease
    }
  })
  console.log("addReleaseAPI 응답:", response.data)
  return response.data
}

export const updateReleaseAPI = async (updaterelease: Updaterelease) => {
  console.log("updateReleaseAPI 요청 데이터:", updaterelease)
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...updaterelease
    }
  })
  console.log("updateReleaseAPI 응답:", response.data)
  return response.data
}

export const deleteReleaseAPI = async (id: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id
    }
  })
  console.log("deleteReleaseAPI 응답:", response.data)
  return response.data
}

export const paginationReleaseAPI = async (relfilter: relfilter) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      ...relfilter
    }
  })
  console.log("paginationReleaseAPI 응답:", response.data)
  return response.data.data.totalpage
}